// @ts-nocheck
import React from "react";
import { FaChevronRight } from "react-icons/fa";
import { useLanguageContext } from "../context/languageContext";
import businessConfig from "../config/business";
import imgDhomeDyshe from "../assets/images/rifat/hotel/dhome-dyshe.jpg";
import imgDhomeTreshe from "../assets/images/rifat/hotel/dhome-treshe.jpg";

/**
 * Hotel banner.
 *
 * Most guests scan the QR code at the table to eat and never learn there are rooms
 * upstairs, so the page says so on the way out.
 *
 * Sea teal and aqua rather than the navy and sand of the welcome and specialities
 * blocks. The rooms are a different offering from the kitchen and should not read as
 * one more course - and three navy panels stacked down the page merge into one. The
 * green also sits better against the sage walls in both room photos.
 *
 * Two rooms, two photos, one link out to the booking page. No prices: they move with
 * the season and nothing here would know when they had.
 *
 * Photos belong to the hotel - taken from rifatpeshkatari.com.
 */
export const HotelBanner = () => {
    const { t } = useLanguageContext();
    const hotel = businessConfig.hotel;

    if (!hotel?.bookingUrl) return null;

    const rooms = [
        { img: imgDhomeDyshe, name: t("roomDouble", "Double Room") },
        { img: imgDhomeTreshe, name: t("roomTriple", "Triple Room") },
    ];

    return (
        <section className="px-4 pt-2 pb-6">
            <div className="relative overflow-hidden rounded-[1.25rem] bg-[#0D3B38] shadow-[0_10px_30px_-16px_rgba(13,59,56,0.9)]">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-16 -right-12 w-48 h-48 rounded-full bg-[#1B6B63] opacity-50 blur-[70px]"></div>
                </div>

                <div className="relative z-10 px-5 pt-5">
                    <p className="text-[8px] font-black uppercase tracking-[0.22em] text-[#7ECDC0]">
                        {t("hotelNote", "Stay in comfort with a sea view")}
                    </p>
                    <h2 className="mt-1 text-lg font-clash text-white tracking-tight">
                        {t("hotelTitle", "Our hotel")}
                    </h2>
                    <div className="mt-2 h-px w-10 bg-[#7ECDC0]/60"></div>
                    <p className="mt-2.5 text-[11px] font-medium leading-snug text-white/45">
                        {t("hotelText", "Modern rooms by the sea in Durrës, with private bathrooms and a seafood breakfast.")}
                    </p>
                </div>

                <div className="relative z-10 grid grid-cols-2 gap-2.5 px-5 pt-4">
                    {rooms.map((room) => (
                        <div key={room.name} className="min-w-0">
                            <div className="aspect-[4/3] rounded-xl overflow-hidden bg-white/10 ring-1 ring-white/15">
                                <img
                                    src={room.img}
                                    alt={room.name}
                                    loading="lazy"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <p className="mt-1.5 text-[11px] font-bold text-white leading-snug truncate">
                                {room.name}
                            </p>
                            <p className="text-[9.5px] font-medium text-white/40 leading-snug truncate">
                                {t("privateBathroom", "Private bathroom")}
                            </p>
                        </div>
                    ))}
                </div>

                <a
                    href={hotel.bookingUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="relative z-10 mt-4 flex items-center justify-center gap-2 px-5 py-3.5 bg-white/[0.06] border-t border-white/10 text-[#7ECDC0] active:bg-white/[0.12] transition-colors"
                >
                    <span className="text-[10px] font-black uppercase tracking-[0.2em]">
                        {t("bookNow", "Book now")}
                    </span>
                    <FaChevronRight size={9} className="opacity-60" />
                </a>
            </div>
        </section>
    );
};

export default HotelBanner;
